export default __webpack_public_path__ + "static/media/A13466EA-339F-4FF5-967C-8C60B2E434D2.73ca3728.jpeg";